import React, { useEffect, useRef, useCallback } from "react";
import { DISCLAIMER_FULL_TEXT, IACCESSIBLE_URL } from "../content/disclaimer";
import "./DisclaimerModal.css";

export default function DisclaimerModal({ isVisible, onClose }) {
    const dialogRef = useRef(null);
    const previousFocusRef = useRef(null);

    const trapFocus = useCallback((e) => {
        if (e.key === "Escape") {
            onClose();
            return;
        }
        if (e.key !== "Tab") return;
        const dialog = dialogRef.current;
        if (!dialog) return;
        const focusable = dialog.querySelectorAll(
            'button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'
        );
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey) {
            if (document.activeElement === first) {
                e.preventDefault();
                last.focus();
            }
        } else {
            if (document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    }, [onClose]);

    useEffect(() => {
        if (!isVisible) return;
        previousFocusRef.current = document.activeElement;
        const dialog = dialogRef.current;
        if (dialog) {
            const closeBtn = dialog.querySelector("button");
            if (closeBtn) closeBtn.focus();
        }
        document.addEventListener("keydown", trapFocus);
        return () => {
            document.removeEventListener("keydown", trapFocus);
            const previousFocus = previousFocusRef.current;
            if (previousFocus && document.contains(previousFocus) && typeof previousFocus.focus === "function") {
                previousFocus.focus();
            }
        };
    }, [isVisible, trapFocus]);

    if (!isVisible) return null;

    return (
        <div
            className="disclaimer-modal-overlay"
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div
                ref={dialogRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby="disclaimer-modal-title"
                className="disclaimer-modal fade-in-up"
            >
                <h2 id="disclaimer-modal-title" className="disclaimer-modal-title">
                    Disclaimer
                </h2>
                <p className="disclaimer-modal-body">
                    {DISCLAIMER_FULL_TEXT}{" "}
                    <a href={IACCESSIBLE_URL} target="_blank" rel="noopener noreferrer">
                        iaccessible.com
                    </a>
                    .
                </p>
                <button type="button" className="disclaimer-modal-close" onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
    );
}
